import { lazy } from './lazy';
export const registerDirective = (app) => {
  lazy(app);
};
